module.exports = "//cdn.livechat-static.com/webapp/img/logo-livechat.svg?cb4de41d157370d9747cccaf17ceafc3";